<template>
	<inline-svg v-bem :src="path"/>
</template>

<script>
export default {
	name: 'Icon',
	props: ['name'],
	computed: {
		path() { return require(`@/assets/img/icons/DigitalPictogram_${this.name.toUpperCase()}.svg`) }
	}
}
</script>

<style lang="scss" scoped>
.icon {
	width: rem(32);
	height: rem(32);
	fill: currentColor;
	vertical-align: middle;
	@include transition(fill, stroke);
}
</style>
